import React from "react";
import { JobListing } from "@lib/types/jobTypes";
import { Badge } from "@mantine/core";
import isDateNear from "@lib/utils/date/isDateNear";
import shortenStringToLength from "@lib/utils/string/shortenStringToLength";
import stripHtmlTags from "@lib/utils/string/stripHtmlTags";

function SmallJobCard({
  job,
  active,
  className,
  ...props
}: {
  job: JobListing;
  active?: boolean;
  className?: string;
  [key: string]: any;
}) {
  return (
    <button
      className={`p-5 border border-gray-200 rounded-xl text-left duration-200 w-full bg-white ${
        active ? "border-brand-700" : ""
      } ${className || ""}`}
      data-test="small-job-card"
      {...props}
    >
      {/* Less than 15km away = very close */}
      {job.distance && job.distance < 15 && (
        <Badge size="lg" mr="md" mb="xs" color="indigo">
          🗺️ Nur {Math.round(job.distance)}km entfernt
        </Badge>
      )}
      {/* Published in the last 7 days = new */}
      {job.published_at && isDateNear(job.published_at) && (
        <Badge size="lg" mr="md" mb="xs">
          ✨ Neu!
        </Badge>
      )}
      {/* Published 8-20 days ago = popular */}
      {job.published_at &&
        !isDateNear(job.published_at) &&
        isDateNear(job.published_at, 20) && (
          <Badge size="lg" mr="md" mb="xs" color="green">
            📈 Gerade beliebt
          </Badge>
        )}
      {/* Application date in 3 days or less = almost ending */}
      {job.application_end && isDateNear(job.application_end, 3) && (
        <Badge size="lg" mr="md" mb="xs" color="red">
          ⏱️ Bald vorbei!
        </Badge>
      )}
      <h3
        className={`${active ? "text-slate-800" : ""} font-bold text-xl mb-3`}
      >
        {job.title}
      </h3>
      <p className={`text-sm text-gray-600`}>{job.company.name}</p>
      <p className="text-sm whitespace-pre-line overflow-x-hidden text-gray-400 mt-3">
        {job.short_description?.length
          ? job.short_description
          : shortenStringToLength(stripHtmlTags(job.description), 150)}
      </p>
    </button>
  );
}

export default SmallJobCard;
